import { render } from "./Popups.vue?vue&type=template&id=c16c23a0&scoped=true"
import script from "./Popups.vue?vue&type=script&lang=js"
export * from "./Popups.vue?vue&type=script&lang=js"

import "./Popups.vue?vue&type=style&index=0&id=c16c23a0&scoped=true&lang=less"

import exportComponent from "E:\\Object\\xin_poc_mini\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c16c23a0"]])

export default __exports__